import { Variant } from '@/typings/base'

export const getProductVariantIdByCode = (
  variants: Variant[],
  code: string
): number | string => {
  return variants.findIndex((variant) => variant.code === code)
}
